module.exports = __webpack_public_path__ + "img/cbmp.c7765b99.png";